import CuratorPage from './curator-page'

export default CuratorPage
